// extracted by mini-css-extract-plugin
export default {"sidenav":"Sidenav_sidenav__p+JeO","sidenavCollapsed":"Sidenav_sidenavCollapsed__XcQz-"};